<template>
  <div class="main-container" v-if="status">
    <div :class="['card', rotate && 'rotate']">
      <div class="front">
        <slot></slot>
      </div>
      <div :class="['back', statusClass]">{{ status }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Flipper",
  props: {
    status: String,
    active: Boolean
  },
  data: function() {
    return { rotate: false };
  },
  computed: {
    statusClass: function() {
      switch (this.status) {
        case "Produção":
          return "green";
        case "Parada":
          return "red";
        case "Setup":
          return "cyan";
        case "Ocioso":
          return "blue";
        default:
          return "";
      }
    }
  },
  watch: {
    status: function(a, b) {
      if (this.active && b !== "Indef." && b !== a) {
        this.rotate = true;
      }
    },
    rotate: function() {
      if (this.rotate) {
        setTimeout(() => (this.rotate = false), 1500);
      }
    }
  }
};
</script>

<style>
.main-container {
  position: relative;
}

.card {
  position: absolute;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: all 0.5s ease;
}

.rotate {
  transform: rotateY(180deg);
}

.front {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  font-size: 5rem;
  font-weight: bold;
  transform: rotateY(180deg);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.green {
  background-color: var(--color-success);
}
.red {
  background-color: var(--color-stop);
}
.cyan {
  background-color: var(--color-setup);
}
.blue {
  background-color: var(--color-danger);
}
</style>
